import React from 'react'
import { makeStyles } from '@mui/styles'

import { ClassesType } from '../types'

const useStyles = makeStyles(
  theme => ({
    divider: {
      borderRight: theme.constants.inactiveBorder,
      height: 18,
    },
  }),
  { name: 'VerticalDivider' },
)

export interface VerticalDividerProps {
  readonly classes?: ClassesType<typeof useStyles>
}

const VerticalDivider = ({ classes: classesProp }: VerticalDividerProps) => {
  const classes = useStyles({ classes: classesProp })

  return <span className={classes.divider} />
}

export default VerticalDivider
